import React from "react";
var __jsx = React.createElement;
import OilProductCardHeader from "./OilProductCardHeader";
import OilOptionCard from "./OilOptionCard";
var OilProductCard = function OilProductCard(_ref) {
  var section = _ref.section;
  var content = section.content;
  var cartTitle = "".concat(content.title, " ").concat(content.sub_title);
  return /*#__PURE__*/React.createElement("div", {
    className: "px-4 md:px-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white border border-[#E6EEFF] rounded-xl shadow-[0_2px_8px_rgba(27,32,53,0.04)] px-4 pt-3 pb-6 mb-4 md:max-w-[1200px] md:mx-auto md:mb-8 md:rounded-xl md:border-[#E6EEFF] md:p-8 md:shadow-none"
  }, /*#__PURE__*/React.createElement(OilProductCardHeader, {
    logo: content.logo,
    title: content.title,
    subTitle: content.sub_title,
    ctaLink: content.cta_link,
    ctaLabel: content.cta_label
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 md:gap-4 overflow-x-auto pb-0.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:overflow-x-visible"
  }, content.options.map(function (option) {
    var _option$id;
    return /*#__PURE__*/React.createElement(OilOptionCard, {
      key: (_option$id = option.id) !== null && _option$id !== void 0 ? _option$id : option.value,
      option: option,
      productId: content.id,
      cartTitle: cartTitle,
      productName: content === null || content === void 0 ? void 0 : content.sub_title,
      productLogo: content.logo
    });
  }))));
};
export default OilProductCard;